// Bilingual copy. Norwegian first, English fallback.
export const COPY = {
  no: {
    nav: {
      tagline: "Den digitale tvillingen",
      book: "Book en prat",
      chat: "Snakk med meg",
    },
    hero: {
      kicker: "Nettpilot · Digital tvilling · 24/7",
      title_1: "Møt din digitale",
      title_2: "Nickolass.",
      lede:
        "25+ år med SEO, AI og litt sprintcoaching — pakket inn i en samtale. Spør hva som helst. Hvis det blir alvor, henter jeg den ekte fyren med hatten.",
      photo_alt: "Nickolass Jensen med signaturhatten",
      cta_chat: "Start en prat",
      cta_real: "Hent den ekte Nickolass",
    },
    chat: {
      title: "AI_NICKOLASS // v1.0",
      placeholder: "Skriv noe… SEO, 3LA, AI, sprint, WordPress…",
      send: "Send",
      thinking: "tenker",
      you: "DU",
      bot: "NICKOLASS",
      fromBlog: "Fra bloggen",
      reset: "ny samtale",
      suggestPrefix: "Prøv:",
      suggestions: [
        "Forklar 3LA på 30 sekunder",
        "Hvordan blir jeg sitert av ChatGPT?",
        "Bygg meg en chatbot — hvor begynner jeg?",
        "Gjør meg raskere på 100 m",
      ],
      welcome:
        "Hei. Jeg er den digitale Nickolass — bygd på 25+ år med SEO, GEO og AI-strategi (og et lite snev av sprintcoaching). Hvor trykker skoen?",
    },
    skills: {
      kicker: "Verktøykassa",
      title: "Det jeg gjør på en god dag",
      items: [
        {
          tag: "01 / GEO",
          title: "Three-Layer Approach™",
          body:
            "Optimalisering for mennesker, søkemotorer og AI-agenter. Bli sitert i ChatGPT, Perplexity og Gemini — ikke bare rangert i Google.",
        },
        {
          tag: "02 / WP",
          title: "WordPress-plugins",
          body:
            "Guardian (AI-defense), 3LA Connector, AI Context Engine for llms.txt, og WooCommerce-integrasjoner som faktisk holder.",
        },
        {
          tag: "03 / AI",
          title: "AI-assistenter & agenter",
          body:
            "Kira, Mia, Mattson, Coach T. Skreddersydde chatbots, MCP-er og agenter for norske bedrifter — med dokumentert ROI.",
        },
        {
          tag: "04 / SEO",
          title: "Klassisk SEO + Google Ads",
          body:
            "Teknisk SEO, søkeordsanalyse, lokal synlighet, konvertering. Foundation før du bygger AI-laget.",
        },
        {
          tag: "05 / SPRINT",
          title: "Sprintcoaching",
          body:
            "Biomekanikk, videoanalyse, 10-sekunders prompten. Sprintcamp.no og Elitesprinttrening.no — fart krever klare cues.",
        },
        {
          tag: "06 / WORKSHOPS",
          title: "Mastering AI in Business",
          body:
            "Énedags workshop for ledere som vil ta igjen AI-toget uten å gå i grøfta. Vi kommer gjerne på besøk.",
        },
      ],
    },
    about: {
      kicker: "Dobbeltliv",
      title: "Halvt strateg. Halvt sprinttrener.",
      body_1:
        "Jeg har jobbet profesjonelt som webmaster siden 2001 — den gang som medlem av Prosa, forbundet for IT-profesjonelle i Danmark — og flyttet til Norge i 2003. Til daglig styrer jeg Nettpilot fra et hjemmekontor på Jevnaker, Akershus. Vi er et lite byrå med stort nettverk — og en voksende stab av AI-assistenter som gjør oss raskere uten at vi mister sjelen.",
      body_2:
        "På fritiden er jeg sprintpappa. Sønnen min Valentin er dansk mester på 60 m. Jeg holder camp, skriver coaching cues, og prøver å holde tritt med 14-åringer på banen.",
      body_3:
        "Begge verdener handler om det samme: klarhet, repetisjon og presise instruksjoner. Det er derfor denne digitale tvillingen finnes — så du kan stille spørsmål når jeg er på trening.",
      ribbon: ["SEO", "GEO", "3LA™", "AI-AGENTS", "WORDPRESS", "WOOCOMMERCE", "SPRINT COACHING", "WORKSHOPS", "JEVNAKER, NO", "SIDEN 2003"],
    },
    lead: {
      kicker: "Hent den ekte fyren",
      title_1: "Klar for å snakke",
      title_2: "med mennesket?",
      body:
        "Skriv noen linjer. Det går rett til Nickolass. Eller book en gratis 20-min prat med kalenderen hans.",
      name: "Navnet ditt",
      email: "E-post",
      message: "Hva trenger du hjelp med?",
      submit: "Send beskjed",
      booking: "Book en gratis prat →",
      success: "Sendt. Nickolass tar kontakt — som regel innen 4 timer på dagtid.",
      fail: "Hmm, noe gikk skeis. Prøv igjen eller ring +47 400 43 101.",
      consent: "Ved å sende godtar du vår",
      consent_link: "personvernerklæring",
      consent_after: ".",
    },
    footer: {
      tagline: "Nettpilot AS · Jevnaker, Akershus · Siden 2003",
      phone: "Ring",
      linkedin: "LinkedIn",
      site: "nettpilot.no",
      privacy: "Personvern",
      disclaimer:
        "Dette er en digital tvilling. Hyggelig, men ikke den ekte. Sannferdig på det den vet, og ærlig på det den ikke vet.",
    },
  },
  en: {
    nav: {
      tagline: "The digital twin",
      book: "Book a call",
      chat: "Talk to me",
    },
    hero: {
      kicker: "Nettpilot · Digital twin · 24/7",
      title_1: "Meet your digital",
      title_2: "Nickolass.",
      lede:
        "25+ years of SEO, AI and a bit of sprint coaching — folded into a conversation. Ask anything. If it gets serious, I'll bring the real guy with the hat.",
      photo_alt: "Nickolass Jensen wearing his signature hat",
      cta_chat: "Start a chat",
      cta_real: "Bring the real Nickolass",
    },
    chat: {
      title: "AI_NICKOLASS // v1.0",
      placeholder: "Type something… SEO, 3LA, AI, sprints, WordPress…",
      send: "Send",
      thinking: "thinking",
      you: "YOU",
      bot: "NICKOLASS",
      fromBlog: "From the blog",
      reset: "new chat",
      export: "export",
      deleteMine: "delete chat",
      deletedToast: "Your chat has been deleted.",
      exportFail: "Couldn't export — try again.",
      suggestPrefix: "Try:",
      suggestions: [
        "Explain 3LA in 30 seconds",
        "How do I get cited by ChatGPT?",
        "Build me a chatbot — where do I start?",
        "Make me faster on the 100m",
      ],
      welcome:
        "Hey. I'm the digital Nickolass — built on 25+ years of SEO, GEO and AI strategy (with a side of sprint coaching). What's pinching?",
    },
    skills: {
      kicker: "The toolkit",
      title: "What I do on a good day",
      items: [
        {
          tag: "01 / GEO",
          title: "Three-Layer Approach™",
          body:
            "Optimization for humans, search engines, and AI agents. Get cited in ChatGPT, Perplexity and Gemini — not just ranked in Google.",
        },
        {
          tag: "02 / WP",
          title: "WordPress plugins",
          body:
            "Guardian (AI-defense), 3LA Connector, AI Context Engine for llms.txt, and WooCommerce integrations that actually hold up.",
        },
        {
          tag: "03 / AI",
          title: "AI assistants & agents",
          body:
            "Kira, Mia, Mattson, Coach T. Custom chatbots, MCP servers and agents for Nordic businesses — with documented ROI.",
        },
        {
          tag: "04 / SEO",
          title: "Classic SEO + Google Ads",
          body:
            "Technical SEO, keyword research, local visibility, conversion. The foundation before you build the AI layer.",
        },
        {
          tag: "05 / SPRINT",
          title: "Sprint coaching",
          body:
            "Biomechanics, video analysis, the 10-second prompt. Sprintcamp.no and Elitesprinttrening.no — speed needs clear cues.",
        },
        {
          tag: "06 / WORKSHOPS",
          title: "Mastering AI in Business",
          body:
            "A one-day workshop for leaders who want to catch the AI train without falling off it. Happy to come to you.",
        },
      ],
    },
    about: {
      kicker: "A double life",
      title: "Half strategist. Half sprint coach.",
      body_1:
        "I've worked professionally as a webmaster since 2001 — back then a member of Prosa, the IT professionals' union in Denmark — and moved to Norway in 2003. Most days I run Nettpilot from a home office in Jevnaker, an hour outside Oslo. We're a small studio with a large network — and a growing crew of AI assistants that make us faster without losing the soul.",
      body_2:
        "Off-hours I'm a sprint dad. My son Valentin is Danish 60m champion. I run camps, write coaching cues, and try to keep up with 14-year-olds on the track.",
      body_3:
        "Both worlds are about the same thing: clarity, repetition, and precise instructions. That's why this digital twin exists — so you can ask things while I'm at practice.",
      ribbon: ["SEO", "GEO", "3LA™", "AI-AGENTS", "WORDPRESS", "WOOCOMMERCE", "SPRINT COACHING", "WORKSHOPS", "JEVNAKER, NO", "SINCE 2003"],
    },
    lead: {
      kicker: "Bring the real one",
      title_1: "Ready to talk",
      title_2: "to a human?",
      body:
        "Drop a few lines. It goes straight to Nickolass. Or book a free 20-min intro call on his calendar.",
      name: "Your name",
      email: "Email",
      message: "What do you need help with?",
      submit: "Send message",
      booking: "Book a free call →",
      success: "Sent. Nickolass usually replies within 4 hours during weekdays.",
      fail: "Hmm, something broke. Try again or call +47 400 43 101.",
      consent: "By submitting you agree to our",
      consent_link: "privacy policy",
      consent_after: ".",
    },
    footer: {
      tagline: "Nettpilot AS · Jevnaker, Norway · Since 2003",
      phone: "Phone",
      linkedin: "LinkedIn",
      site: "nettpilot.no",
      privacy: "Privacy",
      disclaimer:
        "This is a digital twin. Friendly, but not the real one. Truthful where it knows, honest where it doesn't.",
    },
  },
};

// Local stylized assets — Nettpilot.no images are behind hotlink/captcha protection.
export const PHOTO = "/img/nickolass-hat.svg";
export const LOGO = "/img/nettpilot-logo.svg";
export const TRACK =
  "https://images.unsplash.com/photo-1526676317768-d9b14f15615a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxzcHJpbnQlMjB0cmFjayUyMGxhbmVzfGVufDB8fHx8MTc3NzU5MjQ0MHww&ixlib=rb-4.1.0&q=85";
export const LANDSCAPE =
  "https://images.unsplash.com/photo-1772105496255-a71d71d3927c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwxfHxzY2FuZGluYXZpYW4lMjBtaW5pbWFsJTIwbGFuZHNjYXBlfGVufDB8fHx8MTc3NzU5MjQ0MHww&ixlib=rb-4.1.0&q=85";

export const BOOKING_URL = "https://nettpilot.no/book-avtale/";
export const PHONE = "+47 400 43 101";
export const LINKEDIN = "https://www.linkedin.com/in/nickolass";
export const SITE = "https://nettpilot.no";
 "https://nettpilot.no";
